import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useAddPartnerModal } from '../context/AddPartnerModalContext';

const PersonTypeSection: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddPartnerModal();

  return (
    <>
      <div className="row mb-3">
        <div className="col-6">
          <div className="custom-control custom-radio">
            <input
              type="radio"
              className="custom-control-input"
              name="natural-person"
              id="natural-person"
              checked={data.naturalPerson}
              onChange={actions.handleChangeNaturalPerson}
            />
            <label className="custom-control-label" htmlFor="natural-person">
              {t('NaturalPerson')}
            </label>
          </div>
        </div>
        <div className="col-6">
          <div className="custom-control custom-radio">
            <input
              type="radio"
              className="custom-control-input"
              name="legal-person"
              id="legal-person"
              checked={!data.naturalPerson}
              onChange={actions.handleChangeNaturalPerson}
            />
            <label className="custom-control-label" htmlFor="legal-person">
              {t('LegalPerson')}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonTypeSection;
